import React, { Component } from 'react';

import './bottom-menu.css';
import ConfigurationMenu from './ConfigurationMenu';
import ConnectionMenu from './ConnectionMenu';
import { EscapeMenu } from './EscapeMenu';
import FriendsMenu from './FriendsMenu';


class TimeDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = { currentTime: new Date().toLocaleTimeString() };
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            this.setState({
                currentTime: new Date().toLocaleTimeString()
            });
        }, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return (
            <div id={'time-display'}
                 className={'time-display'}
            >{this.state.currentTime}</div>
        );
    }


}


export default class BottomMenu extends Component {
    constructor(props) {
        super(props);
        props.app.bottomMenu = this;
    }


    render() {
        return (
            <div id={'bottom-menu-anchor'} className={'bottom-menu-anchor'}>
                <div id={'bottom-menu-container'} className={'bottom-menu-container'}>
                    <ConnectionMenu {...this.props} />
                    <ConfigurationMenu {...this.props} />
                    <FriendsMenu {...this.props} />
                    <EscapeMenu {...this.props} />
                    <TimeDisplay {...this.props} />
                </div>
            </div>
        );
    }
}
